import saperavi from '../saperavi.png';
import chkhaveri from '../chkhaveri.png';
import khikhvi from '../khikhvi.png'
import kindzmarauli from '../kindzmarauli.png';
import shavkapito from '../shavkapito.png';

export const latestTranslations ={
    GE: {
        title: "ჩვენი უახლესი ღვინო",
        pageTitle: "ღვინის კოლექცია",
        pageSubtitle: "ქართული ტრადიციული მეღვინეობის რჩეული ნიმუშები",
        cardCta: "ვრცლად",
        button: "გაიგეთ მეტი",
        contact: 'დაგვიკავშირდით',
        products: [ 
            {
                title: "საფერავი",
                description: "კახეთის რეგიონში მოწეული ყურძნისგან დამზადებული წითელი, მშრალი ღვინო „საფერავი“",
                src: saperavi
            },
            {
                title: "ჩხავერი",
                description: "აჭარის რეგიონში მოწეული ყურძნისგან დამზადებული ვარდისფერი, ნახევრად ტკბილი ღვინო “ჩხავერი”",
                src: chkhaveri
            },
            {
                title: "ხიხვი",
                description: "კახეთის რეგიონში მოწეული ყურძნისგან დამზადებული, ქვევრში სამ თვიანი დაყოვნებით, ღვინო ქარვისფერი, მშრალი „ხიხვი“",
                src: khikhvi
            },
            {
                title: "ქინძმარაული",
                description: "კახეთის რეგიონში მოწეული ყურძნისგან დამზადებული, დაცული ადგილწარმოშობის ღვინო, წითელი, ბუნებრივად ნახევრად ტკბილი „ქინძმარაული“",
                src: kindzmarauli
            },
            {
                title: "შავკაპიტო",
                description: "შიდა ქართლში მოწეული ყურძნისგან დამზადებული, ქვევრში ექვს თვიანი დაყოვნებით, ღვინო წითელი, მშრალი „შავკაპიტო“",
                src: shavkapito
            },
        ]
    },
    EN: {
        title: "Our Latest Wines",
        pageTitle: "Wine Collection",
        pageSubtitle: "Handcrafted wines representing authentic Georgian terroir and tradition",
        cardCta: "Learn More",
        button: "Learn More",
        contact: 'Contact Us',
        products: [
            {
                title: "Saperavi",
                description: "A red, dry wine made from grapes harvested in the Kakheti region.",
                src: saperavi
            },
            {
                title: "Chkhaveri",
                description: "A pink, semi-sweet wine made from grapes harvested in the Adjara region.",
                src: chkhaveri
            },
            {
                title: "Khikhvi",
                description: "A amber, dry wine made from grapes harvested in the Kakheti region, aged for three months in qvevri.",
                src: khikhvi
            },
            {
                title: "Kindzmarauli",
                description: "A red, naturally semi-sweet wine made from grapes harvested in the Kakheti region, protected designation of origin.",
                src: kindzmarauli
            },
            {
                title: "Shavkapito",
                description: "A red, dry wine made from grapes harvested in the Shida Kartli region, aged for six months in qvevri.",
                src: shavkapito
            },
        ]
    },
    RU: {
        title: "Наши последние вина",
        pageTitle: "Винная коллекция",
        pageSubtitle: "Отборные вина, воплощающие подлинный грузинский терруар и традиции",
        cardCta: "Подробнее",
        button: "Узнать больше",
        contact: 'Связаться с нами',
        products: [
            {
                title: "Саперави",
                description: "Красное, сухое вино, изготовленное из винограда, собранного в регионе Кахетия.",
                src: saperavi
            },
            {
                title: "Чхавери",
                description: "Розовое, полусладкое вино, изготовленное из винограда, собранного в регионе Аджария.",
                src: chkhaveri
            },
            {
                title: "Хихви",
                description: "Янтарное, сухое вино, изготовленное из винограда, собранного в регионе Кахетия, выдержанное три месяца в кверви.",
                src: khikhvi
            },
            {
                title: "Киндзмараули",
                description: "Красное, натуральное полусладкое вино, изготовленное из винограда, собранного в регионе Кахетия, защищенное наименование происхождения.",
                src: kindzmarauli
            },
            {
                title: "Шавкапито",
                description: "Красное, сухое вино, изготовленное из винограда, собранного в регионе Шида-Картли, выдержанное шесть месяцев в кверви.",
                src: shavkapito
            },
        ]
    }
}